import React from 'react';
import { LlmModel, useLlmModelsService } from 'nekst-api';
import { useDataLoaderNew } from 'data-loader';
import { useChatWidgetContext } from '../../ChatWidgetContext';
import styles from '../ChatWidget.module.scss';

interface ActiveModelNameProps {
  className?: string;
  prefix?: string;
}

export default function ActiveModelName(props: ActiveModelNameProps) {
  const { activeModelId } = useChatWidgetContext();
  const modelsService = useLlmModelsService();
  const { data: models } = useDataLoaderNew<LlmModel[]>(modelsService.getModels);

  if (!activeModelId || !models) {
    return null;
  }

  const model = models.find((m) => m.id === activeModelId);
  const displayName = model?.displayName ?? activeModelId;

  return <div className={props.className ?? styles.headerSubtitle}>{props.prefix}{displayName}</div>;
}
